import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GroupRegFormConfiguration from "./PackageSetup/RegistrationForm/RegistrationForm";
import PackagesTable from "./PackagesTable/PackagesTable";
import ScreenHeader from "../../../../CommonComponents/ScreenHeader";
import ChantButton from "../../../../CommonComponents/ChantButton/ChantButton";
import IconContainer from "../../../../CommonComponents/IconContainer";
import { PlusOutlined } from "@ant-design/icons";
import { isMobile } from "../../../../utils/helper";
import "./Packages.css";
import TabNav from "../../../../CommonComponents/TabNav/TabNav";
import FAQ from "../../help/FAQ";
import { faqSections } from "../../help/faqData";

const Packages = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = () => {
    if (location.pathname.includes("/setup")) {
      return "setup";
    }
    if (location.pathname.includes("/faq")) {
      return "faq";
    }
    return "list";
  };

  const tabItems = [
    {
      key: "list",
      label: "Packages",
    },
    {
      key: "setup",
      label: "Setup",
    },
    {
      key: "faq",
      label: "FAQ",
    },
  ];

  const handleTabChange = (tabKey) => {
    switch (tabKey) {
      case "list":
        navigate("/admin/members/packages");
        break;
      case "setup":
        navigate("/admin/members/packages/setup");
        break;
      case "faq":
        navigate("/admin/members/packages/faq");
        break;
      default:
        navigate("/admin/members/packages");
    }
  };

  const handleAddPackage = () => {
    navigate("/admin/members/packages/create");
  };

  const renderContent = () => {
    if (location.pathname.includes("/setup")) {
      return <GroupRegFormConfiguration />;
    }
    if (location.pathname.includes("/faq")) {
      return (
        <FAQ
          sections={faqSections.filter((s) => s.id === "packages")}
          showSearch={false}
        />
      );
    }
    return <PackagesTable addPackage={handleAddPackage} />;
  };

  return (
    <div className="packages-container">
      <ScreenHeader
        title="Packages"
        actions={
          <>
            {getCurrentTab() === "list" && (
              <div>
                {isMobile() ? (
                  <IconContainer
                    onClick={handleAddPackage}
                    iconComponent={<PlusOutlined />}
                    iconStyle={{ fontSize: "16px" }}
                  />
                ) : (
                  <ChantButton onClick={handleAddPackage}>
                    Add Package
                  </ChantButton>
                )}
              </div>
            )}
          </>
        }
      />

      <div style={{ paddingTop: "2px" }}>
        <TabNav
          items={tabItems}
          activeKey={getCurrentTab()}
          handleTabChange={handleTabChange}
        />
      </div>

      <div className="packages-content">{renderContent()}</div>
    </div>
  );
};

export default Packages;
